<script setup lang="ts">
import type { CustomerAddress } from '@/types/rc/customers/CustomerContactDetails'

defineProps<{ address: CustomerAddress }>()
</script>

<template>
  <el-descriptions :column="1">
    <el-descriptions-item label="Address Line 1">{{ address?.address_1 || '-' }}</el-descriptions-item>
    <el-descriptions-item label="Address Line 2">{{ address?.address_2 || '-' }}</el-descriptions-item>
    <el-descriptions-item label="City">{{ address?.city || '-' }}</el-descriptions-item>
    <el-descriptions-item label="State">{{ address?.state || '-' }}</el-descriptions-item>
    <el-descriptions-item label="Zip Code">{{ address?.zip || '-' }}</el-descriptions-item>
    <el-descriptions-item label="Country">{{ address?.country || '-' }}</el-descriptions-item>
  </el-descriptions>
</template>

<style scoped>
::v-deep(.el-descriptions__cell) {
  display: inline-flex;
}

::v-deep(.el-descriptions__label) {
  width: 148px;
}
</style>
